// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table search bar - matches admin panel theme */
.TableSearchBar_searchWrap__Hyqfk {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 280px;
  padding: 0.5rem 0.75rem;
  background: #ffffff;
  border: 1px solid rgba(135, 206, 235, 0.4);
  border-radius: 0.5rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.TableSearchBar_searchWrap__Hyqfk:focus-within {
  border-color: #87ceeb;
  box-shadow: 0 0 0 2px rgba(135, 206, 235, 0.25);
}

.TableSearchBar_searchIcon__Ba2uE {
  flex-shrink: 0;
  color: #87ceeb;
  pointer-events: none;
}

.TableSearchBar_searchInput__xTumZ {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  font-size: 0.875rem;
  color: #000000;
  background: transparent;
}

.TableSearchBar_searchInput__xTumZ::placeholder {
  color: #718096;
}

.TableSearchBar_searchInput__xTumZ::-webkit-search-cancel-button {
  appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/TableSearchBar.module.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,qBAAqB;EACrB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Table search bar - matches admin panel theme */\n.searchWrap {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  max-width: 280px;\n  padding: 0.5rem 0.75rem;\n  background: #ffffff;\n  border: 1px solid rgba(135, 206, 235, 0.4);\n  border-radius: 0.5rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.searchWrap:focus-within {\n  border-color: #87ceeb;\n  box-shadow: 0 0 0 2px rgba(135, 206, 235, 0.25);\n}\n\n.searchIcon {\n  flex-shrink: 0;\n  color: #87ceeb;\n  pointer-events: none;\n}\n\n.searchInput {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  font-size: 0.875rem;\n  color: #000000;\n  background: transparent;\n}\n\n.searchInput::placeholder {\n  color: #718096;\n}\n\n.searchInput::-webkit-search-cancel-button {\n  appearance: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchWrap": `TableSearchBar_searchWrap__Hyqfk`,
	"searchIcon": `TableSearchBar_searchIcon__Ba2uE`,
	"searchInput": `TableSearchBar_searchInput__xTumZ`
};
export default ___CSS_LOADER_EXPORT___;
